import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WaitingassetComponent } from './components/waitingasset/waitingasset.component';
import { CallComponent } from './components/call/call.component';
import { LoaderComponent } from './components/loader/loader.component';
import { UserDataResolver } from './resolvers/UserDataResolver';

const routes: Routes = [
  { path: '', component: LoaderComponent },
  { path: 'waitingasset', component: WaitingassetComponent, resolve: { userData: UserDataResolver } },
  { path: 'call', component: CallComponent },
  { path: ':param1', component: LoaderComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

